import { BASE_QUERY, COMMON_QUERY_CONFIG, ruleNewsPlus, VIDEO_WSJ_NETWORK_QUERY_RULES_CONFIG } from './shared/configs';

enum SECTION_ENUM {
  ACCOUNTING_AND_TAXES = 'Accounting and Taxes'
}

const BASE = {
  ...BASE_QUERY,
  query: {
    ...BASE_QUERY.query,
    or: [{ terms: { key: 'SectionType', value: ['cfo journal'] } }],
    not: [...BASE_QUERY.query.not, ruleNewsPlus]
  }
};

const MAIN = { ...BASE, count: 4 };

const SECTION_TOP = { ...BASE, count: 2 };

const VIDEO = {
  ...COMMON_QUERY_CONFIG,
  query: {
    ...VIDEO_WSJ_NETWORK_QUERY_RULES_CONFIG,
    or: [{ term: { key: 'Keyword', value: 'wsj cfo network summit 2025' } }],
    not: []
  }
};

const ACCOUNTING_AND_TAXES = {
  ...BASE_QUERY,
  query: { ...BASE_QUERY.query, or: [{ terms: { key: 'IndustryCodeName', value: ['accounting'] } }] }
};

const MORE_LIST = { ...BASE };

export { MAIN, SECTION_TOP, VIDEO, ACCOUNTING_AND_TAXES, MORE_LIST, SECTION_ENUM };
